import atlas from "azure-maps-control";

export class MapCenterControl {
  private onClick: () => void;
  private container: HTMLElement | null = null;

  constructor(onClick: () => void) {
    this.onClick = onClick;
  }

  onAdd(_map: atlas.Map): HTMLElement {
    this.container = document.createElement("div");

    this.container.className = "azure-maps-control-container light";
    this.container.style.position = "relative";
    this.container.style.display = "flex";
    this.container.style.flexDirection = "column";

    const button = document.createElement("button");
    button.className = "azure-maps-control-button";
    button.type = "button";
    button.setAttribute("aria-label", "Recenter");
    button.innerHTML = "🎯";

    button.style.cssText = `
      width: 32px; 
      height: 32px; 
      background-color: white; 
      border: none; 
      cursor: pointer; 
      display: flex; 
      align-items: center; 
      justify-content: center;
      border-radius: 4px; 
      box-shadow: 0 0 4px rgba(0,0,0,0.2); 
      margin-bottom: 5px;
    `;

    const tooltip = document.createElement("span");
    tooltip.className = "tooltiptext";
    tooltip.innerText = "Recenter";
    tooltip.style.display = "none";

    button.onmouseenter = () => {
      tooltip.style.display = "block";
    };
    button.onmouseleave = () => {
      tooltip.style.display = "none";
    };
    button.onclick = () => this.onClick();

    this.container.appendChild(button);
    this.container.appendChild(tooltip); // CRITICAL: This was missing
    return this.container;
  }

  onRemove(): void {
    if (this.container?.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
  }
}
